export class ImportMissingInvoiceNumberDocumentSearchCriteriaModel {
    IsPickedStatus: ImportMissingInvoiceNumberDocumentSearchCriteriaModelIsPickedStatuses;

    FromReceptionDate: Date | string | '';

    ToReceptionDate: Date | string | '';
}

export enum ImportMissingInvoiceNumberDocumentSearchCriteriaModelIsPickedStatuses {
    NotPicked = 1,
    Picked = 2,
    All = NotPicked | Picked,
}